import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FrameInfo, ImgBg, ItemInfo, TxtBy, Wrapper } from './style';
import BgDot from '@/assets/images/social/bg_dot.svg';

interface IProps {
  fullWidth?: boolean;
  isSocialPost?: boolean;
}

const Footer = (props: IProps) => {
  const { fullWidth = false, isSocialPost = false } = props;
  const navigate = useNavigate();
  return (
    <Wrapper fullWidth={fullWidth} isSocialPost={isSocialPost}>
      <ImgBg src={BgDot} />
      <TxtBy>{'© 2023 by VisionLab., Inc. All Rights Reserved.'}</TxtBy>
      <FrameInfo isSocialPost={isSocialPost}>
        <ItemInfo onClick={() => navigate('/privacy-policy')}>
          {'Privacy Policy'}
        </ItemInfo>
        <ItemInfo onClick={() => navigate('/terms')}>
          {'Terms of Service'}
        </ItemInfo>
        <ItemInfo onClick={() => navigate('/cookies-policy')}>
          {'Cookies Policy'}
        </ItemInfo>
      </FrameInfo>
    </Wrapper>
  );
};

export default Footer;
